// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604091251/js/" + chunkId + "." + {"44":"614935e1","225":"0fb81384","481":"a7c1cd05","486":"43fdc04b","770":"7e5be52e"}[chunkId] + ".0.12690811888107145.chunk.js";
};